const ICON_COLORS = {
  header: {
    outline: '#606060',
    glyph: '#696969'
  },
  row: {
    outline: '#009BE5',
    glyph: '#009BE5'
  }
}

const InspectDeviceIcon = ({ className, title, variant = 'header' }) => {
  const colors = ICON_COLORS[variant] || ICON_COLORS.header

  return (
    <svg
      aria-hidden={title ? undefined : 'true'}
      className={className}
      fill='none'
      height='20'
      role={title ? 'img' : undefined}
      viewBox='0 0 27 20'
      width='27'
      xmlns='http://www.w3.org/2000/svg'
    >
      {title && <title>{title}</title>}
      <rect
        height='18.5'
        rx='1.25'
        stroke={colors.outline}
        strokeWidth='1.5'
        width='25.5'
        x='0.75'
        y='0.75'
      />
      <circle
        cx='12.5'
        cy='8.5'
        r='3.35'
        stroke={colors.glyph}
        strokeWidth='1.5'
      />
      <path
        d='M15 11L18 14'
        stroke={colors.glyph}
        strokeLinecap='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}

export default InspectDeviceIcon
